import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MainService } from '../../service/main.service';

@Component({
  selector: 'app-check-active-dialog',
  templateUrl: './check-active-dialog.component.html',
  styleUrl: './check-active-dialog.component.scss'
})
export class CheckActiveDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<CheckActiveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public member: any,private mainService: MainService
  ) {}

 

}
